export * from '@primeuix/themes/material/divider';
export { default } from '@primeuix/themes/material/divider';
